import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dark.css';
import App from './App';
import { initNative } from './native/bridge';

const root = ReactDOM.createRoot(document.getElementById('root'));
initNative().finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// --- PWA: daftarkan service worker (production + HTTPS saja) ---
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('[PWA] SW gagal daftar:', e));
  });
}
